import { MonthReportPage } from "./MonthReportPage";

type Props = {};
const MonthReport = (props: Props) => {
	return <MonthReportPage />;
};
export default MonthReport;
